(function () {

  function initDeliveryInfo(block) {
    if (!block) return;

    var tilesEl = block.querySelector('[data-delivery-tiles]');
    if (!tilesEl) return;

    // The snippet is rendered above the buy buttons (in the inventory-status
    // block position in main-product.liquid). Move the whole block to sit
    // directly below the buy buttons before first render - the tiles are
    // empty until render() runs, so the move is never visible. This avoids
    // editing main-product.liquid itself.
    var mainForm = document.querySelector('.js-product-form-main');
    if (mainForm) {
      var buyBlock = mainForm.closest('.product-info__block');
      if (buyBlock) {
        buyBlock.insertAdjacentElement('afterend', block);
      }
    }

    // Move the Judge.me Trust Badge app block into the badge slot. It is
    // rendered on every page inside the hidden trust_badge_host section in
    // the header group (see sections/header-group.json and the collapse rule
    // in snippets/doc-head-core.liquid); moving it out of that section makes
    // it visible here. The native metafield badge is only kept when the app
    // block is missing entirely.
    var badgeSlot = block.querySelector('[data-delivery-badge]');
    var appBadge = document.querySelector('.shopify-app-block[id*="judge_me_reviews_trust_badge"]');
    if (badgeSlot && appBadge) {
      var appBadgeWrapper = appBadge.closest('.product-info__block');
      var nativeBadge = badgeSlot.querySelector('[data-native-badge]');
      if (nativeBadge) nativeBadge.remove();
      badgeSlot.appendChild(appBadge);
      if (appBadgeWrapper && appBadgeWrapper.childElementCount === 0) {
        appBadgeWrapper.style.display = 'none';
      }
    }

    var currentVariantPriceCents = parseInt(block.dataset.initialPrice || '0', 10) || 0;
    var cartTotalCents = 0;

    var rm48free = block.dataset.rm48free === 'true';
    var isPreorder = block.dataset.preorder === 'true';
    var country = block.dataset.country || 'GB';

    var freeDeliveryThresholdCents = 5000;

    var icons = {
      truck: '<svg class="dt-icon" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2"></circle><circle cx="18.5" cy="18.5" r="2"></circle></svg>',

      calendar: '<svg class="dt-icon" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="3" y1="11" x2="21" y2="11"></line></svg>',

      bolt: '<svg class="dt-icon" viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>',

      tool: '<svg class="dt-icon" viewBox="0 0 24 24"><path d="M14.7 6.3a4 4 0 0 0-5 5L3 18l3 3 6.7-6.7a4 4 0 0 0 5-5l-2.8 2.8-3-3z"></path></svg>',

      returns: '<svg class="dt-icon" viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>'
    };

    function moneyFromCents(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    // All dispatch cut-offs and delivery estimates are UK business rules, so
    // compute them against Europe/London rather than the visitor's device
    // clock (a visitor abroad would otherwise see a wrong countdown).
    // Returns a Date whose local fields mirror the current London wall time.
    function nowInLondon() {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        }).formatToParts(new Date());

        var v = {};
        parts.forEach(function (p) {
          if (p.type !== 'literal') v[p.type] = parseInt(p.value, 10);
        });

        return new Date(v.year, v.month - 1, v.day, v.hour === 24 ? 0 : v.hour, v.minute, v.second);
      } catch (e) {
        return new Date();
      }
    }

    function tile(iconKey, caption, sub, extraClass) {
      var html = '<div class="dt-tile' + (extraClass ? ' ' + extraClass : '') + '">' +
        icons[iconKey] +
        '<div class="dt-tile__caption">' + caption;

      if (sub) {
        html += '<span class="dt-tile__sub">' + sub + '</span>';
      }

      html += '</div></div>';

      return html;
    }

    function getCartTotal() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (cart) {
          if (!cart) return;
          cartTotalCents = parseInt(cart.total_price || '0', 10) || 0;
          render();
        })
        .catch(function () {
          cartTotalCents = 0;
          render();
        });
    }

    function getMarketConfig(countryCode, combinedTotalCents) {

      if (countryCode === 'US') {
        return {
          locale: 'en-US',
          priceCaption: 'Shipping to USA from $13.50',
          min: 5,
          max: 7,
          small: 'Tax & Duty included'
        };
      }

      if (countryCode === 'AU') {

        var auMessage;

        if (combinedTotalCents < 100000) {
          auMessage = 'All Tax & Duties Included';
        } else {
          auMessage = 'Tax & Customs Charges paid on import';
        }

        return {
          locale: 'en-AU',
          priceCaption: 'Delivery from $18.90',
          min: 5,
          max: 7,
          small: auMessage
        };
      }

      if (
        countryCode === 'FR' ||
        countryCode === 'DE' ||
        countryCode === 'IE' ||
        countryCode === 'NL' ||
        countryCode === 'BE' ||
        countryCode === 'ES' ||
        countryCode === 'IT' ||
        countryCode === 'AT' ||
        countryCode === 'PT' ||
        countryCode === 'DK' ||
        countryCode === 'SE' ||
        countryCode === 'FI' ||
        countryCode === 'PL' ||
        countryCode === 'CZ' ||
        countryCode === 'SK' ||
        countryCode === 'HU' ||
        countryCode === 'RO' ||
        countryCode === 'BG' ||
        countryCode === 'HR' ||
        countryCode === 'SI' ||
        countryCode === 'EE' ||
        countryCode === 'LV' ||
        countryCode === 'LT' ||
        countryCode === 'LU' ||
        countryCode === 'GR'
      ) {
        return {
          locale: 'en-GB',
          priceCaption: 'International delivery available',
          min: 5,
          max: 10,
          small: 'Tax & Duties paid on import'
        };
      }

      if (countryCode === 'GB') {

        var priceCaption;
        var combinedTotal = combinedTotalCents / 100;

        // RM48FREE items ship free at any price, so the threshold message
        // would be confusing there
        var priceSub = rm48free
          ? 'Delivered to you free of charge'
          : 'Free on orders over £' + (freeDeliveryThresholdCents / 100);

        if (rm48free || combinedTotal >= 50) {

          priceCaption =
            '<strong>' +
            moneyFromCents(currentVariantPriceCents) +
            '</strong> with <strong>free</strong> Tracked Delivery';

        } else if (combinedTotal < 10) {

          priceCaption =
            '<strong>' +
            moneyFromCents(currentVariantPriceCents) +
            '</strong> with Standard Delivery from £1.99';

        } else {

          priceCaption =
            '<strong>' +
            moneyFromCents(currentVariantPriceCents) +
            '</strong> with Tracked Delivery from £3.89';
        }

        return {
          locale: 'en-GB',
          priceCaption: priceCaption,
          priceSub: priceSub,
          min: combinedTotal < 10 ? 3 : 2,
          max: combinedTotal < 10 ? 4 : 3,
          upgrade: true,
          upgradeMin: 1,
          upgradeMax: 2
        };
      }

      return {
        locale: 'en-GB',
        priceCaption: 'International delivery available',
        min: 7,
        max: 14,
        small: 'Final delivery options shown at checkout'
      };
    }

    function isBusinessDay(date) {
      var day = date.getDay();

      // Dispatch Monday-Saturday
      return day >= 1 && day <= 6;
    }

    function getDispatchDate(date) {
      var result = new Date(date);
      var day = result.getDay();

      var cutoff = new Date(date);

      // Saturday cut-off: 11:00
      if (day === 6) {
        cutoff.setHours(11, 0, 0, 0);
      }

      // Monday-Friday cut-off: 14:30
      else {
        cutoff.setHours(14, 30, 0, 0);
      }

      // After cut-off or Sunday = next dispatch day
      if (date > cutoff || !isBusinessDay(result)) {
        do {
          result.setDate(result.getDate() + 1);
        } while (!isBusinessDay(result));
      }

      return result;
    }

    // Royal Mail delivers Monday-Saturday. Only Sunday is skipped.
    function addDeliveryDays(date, days, allowSundayDelivery) {
      var result = new Date(date);
      var added = 0;

      while (added < days) {
        result.setDate(result.getDate() + 1);

        if (!allowSundayDelivery && result.getDay() === 0) {
          continue;
        }

        added++;
      }

      return result;
    }

    function formatRange(dispatchDate, min, max, locale, allowSundayDelivery) {
      var options = {
        month: 'short',
        day: 'numeric'
      };

      var validDispatchDate = getDispatchDate(dispatchDate);

      var start = addDeliveryDays(
        validDispatchDate,
        min,
        allowSundayDelivery
      );

      var end = addDeliveryDays(
        validDispatchDate,
        max,
        allowSundayDelivery
      );

      return start.toLocaleDateString(locale, options) +
             ' - ' +
             end.toLocaleDateString(locale, options);
    }

    function render() {
      var tiles = [];

      var returnsTile = tile(
        'returns',
        '<strong>100 Day</strong> Easy Returns',
        'From the date of purchase'
      );

      if (isPreorder) {

        tiles.push(tile('tool', 'Item made to order in the UK'));

        tiles.push(tile(
          'calendar',
          'Estimated Delivery: <strong>Within 2-3 weeks</strong>',
          'Pay now & we will ship it when in stock'
        ));

        tiles.push(returnsTile);

        tilesEl.innerHTML = tiles.join('');
        return;
      }

      var combinedTotalCents =
        cartTotalCents + currentVariantPriceCents;

      var config = getMarketConfig(
        country,
        combinedTotalCents
      );

      // Tile 1: delivery price
      tiles.push(tile('truck', config.priceCaption, config.priceSub));

      /* COUNTDOWN TILE START */

      var now = nowInLondon();

      var dispatchLabel = 'today';
      var cutoff = new Date(now);

      if (now.getDay() === 6) {
        cutoff.setHours(11, 0, 0, 0);
      } else {
        cutoff.setHours(14, 30, 0, 0);
      }

      if (now > cutoff || now.getDay() === 0) {

        var nextDispatch = getDispatchDate(now);

        var tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);

        if (
          nextDispatch.getDate() === tomorrow.getDate() &&
          nextDispatch.getMonth() === tomorrow.getMonth() &&
          nextDispatch.getFullYear() === tomorrow.getFullYear()
        ) {
          dispatchLabel = 'tomorrow';
        } else {
          dispatchLabel = nextDispatch.toLocaleDateString('en-GB', {
            weekday: 'long'
          });
        }

        cutoff = new Date(nextDispatch);

        if (nextDispatch.getDay() === 6) {
          cutoff.setHours(11, 0, 0, 0);
        } else {
          cutoff.setHours(14, 30, 0, 0);
        }
      }

      var diff = cutoff - now;

      if (country === 'GB' && diff > 0) {

        var hours = Math.floor(diff / (1000 * 60 * 60));
        var minutes = Math.floor((diff / (1000 * 60)) % 60);

        tiles.push(tile(
          'bolt',
          'Order within <strong>' + hours + 'h ' + minutes + 'm</strong> for <strong>dispatch ' + dispatchLabel + '</strong> with Royal Mail or DPD',
          null,
          'dt-tile--countdown'
        ));
      }

      /* COUNTDOWN TILE END */

      // Tile 3: estimated arrival (with 99p upgrade or market note as sub-line).
      // The upgrade sub-line gets the dt-tile--upgrade modifier so it can be
      // coloured to match the tile icons.
      var dispatchDate = nowInLondon();

      var standard = formatRange(
        dispatchDate,
        config.min,
        config.max,
        config.locale,
        false
      );

      var arrivalSub = null;
      var arrivalClass = null;

      if (config.upgrade) {
        var upgrade = formatRange(
          dispatchDate,
          config.upgradeMin,
          config.upgradeMax,
          config.locale,
          true
        );

        arrivalSub = 'Upgrade for only 99p: ' + upgrade;
        arrivalClass = 'dt-tile--upgrade';

      } else if (config.small) {
        arrivalSub = config.small;
      }

      tiles.push(tile(
        'calendar',
        'Estimated Arrival: <strong>' + standard + '</strong>',
        arrivalSub,
        arrivalClass
      ));

      // Tile 4: returns promise (replaces the old header strip message)
      tiles.push(returnsTile);

      tilesEl.innerHTML = tiles.join('');
    }

    document.addEventListener('on:variant:change', function (event) {

      if (!event.detail || !event.detail.variant) return;

      currentVariantPriceCents = event.detail.variant.price;

      render();
    });

    document.addEventListener('cart:updated', getCartTotal);
    document.addEventListener('on:cart:change', getCartTotal);
    document.addEventListener('on:cart:update', getCartTotal);

    // Keep the dispatch countdown fresh while the page is open
    setInterval(render, 60000);

    getCartTotal();
    render();
  }

  function initAll() {
    document
      .querySelectorAll('[data-delivery-info]')
      .forEach(initDeliveryInfo);
  }

  if (document.querySelector('[data-delivery-info]')) {
    initAll();
  }

})();
